module.exports = __webpack_public_path__ + "static/media/delivery_in_progress.3388afd8.svg";